module.exports = __webpack_public_path__ + "static/emm-008-8c7e40bba624252bc6f31f3f82c35178.jpg";